const createLocalDateTime = (localDateString: string, localTimeString: string) => {
  const [year, month, date] = localDateString.split('-');
  const [hours, minutes] = localTimeString.split(':');
  return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(date, 10), parseInt(hours, 10), parseInt(minutes, 10));
};

export default createLocalDateTime;
